import React, {useState} from "react";
import Menu from "../components/common/menu/Menu";
import Sidebar from "../components/common/menu/Sidebar";
import UsersDashboard from "../components/users/UsersDashboard";

function UsersPage() {
    const [sidebarOpen, setSidebarOpen] = useState(false);

    const toggleSidebar = (isOpen) => {
        setSidebarOpen(isOpen);
    };

    return (
        <div className="overflow-hidden dark:bg-dark-950">
            <div className="block md:hidden">
                <Menu sidebarOpen={sidebarOpen} toggleSidebar={toggleSidebar}/>
            </div>

            <div className="hidden md:block">
                <Sidebar/>
            </div>

            <div className="md:ml-[15rem] bg-light-blue-50 relative min-h-screen dark:bg-dark-950">
                <div className="absolute inset-0 opacity-[0.04] dark:opacity-0" style={{
                    backgroundImage: "url(https://i.ibb.co/9kYFDXtW/background-manga.jpg)",
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                }}></div>

                <div className="relative">
                    <div className="flex justify-center items-center">
                        <div className="w-full mt-8 lg:mt-20 mb-56" style={{maxWidth: "1420px"}}>
                            <div className="mx-2 lg:mx-10">
                                <UsersDashboard/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default UsersPage;
